import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=b14a842e&scoped=true&"
import script from "./BusinessCard.vue?vue&type=script&lang=js&"
export * from "./BusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCard.vue?vue&type=style&index=0&id=b14a842e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14a842e",
  null
  
)

export default component.exports